var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w3-container w3-light-grey w3-round-large options-group"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }